// removed by extract-text-webpack-plugin
module.exports = {"label":"p4h8BlRuq7WmM2O2H0Kwp","mobileMultiPin":"A5JfcvdnbIPhboZreXaWm","foreignLabel":"_1SwNQfJ2BZMtXUcJ9bWJ4L"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMLabelNew/OMLabelNew.scss
// module id = 1659
// module chunks = 0